import { message } from "antd";
import { getAllResponsesByProjectIdLocal, trainigonGetAllResponsesByProjectId, updateApiWhitLocalResponses } from "../../api/petitionsTraining";
import { TrainingAddManyResponses } from "../../api";
import { formatingHeaders } from "../helpers";
import { onSetArrayData } from "../tableSlice/tableSlice";
import { addResponsesTraining, setProyectSelectedTraining } from "./vrtSlice";
import { parseColgateMontacargaCsv } from "./colgateMontacargaCsv";

//DEV | PROD
export const COLGATEMONTECARGA = ["-", "6a84b33b0d2cf5f15685e226"]

// Sube el CSV de resultados de Colgate Montacarga (formato acordado con Unity:
// un solo archivo, filas autoidentificadas por lessonId/evaluationId). No reutiliza
// setDataTable porque ese pipeline asume el CSV plano del Colgate viejo (con fila de
// respuestas correctas) y no es consciente de comillas.
export const uploadColgateMontacargaCsv = ({ csvText, projectId }) => {
    return async (dispatch, getState) => {
        const documents = parseColgateMontacargaCsv(csvText);
        const documentsWithProject = documents.map((doc) => ({ ...doc, projectId }));
        const response = await TrainingAddManyResponses(documentsWithProject);
        if (response?.status === 0 || response?.status === undefined) {
            dispatch(getAllResponsesTrainingFormProject(projectId));
            message.success(`Se agregaron ${documentsWithProject.length} resultados`);
            return true;
        }
        message.error("No se pudieron subir los resultados, revisa el archivo");
        return false;
    };
};

export const getAllResponsesTrainingFormProject = (payload) => {
	return async (dispatch, getState) => {
		const response = await trainigonGetAllResponsesByProjectId(payload);
        console.log("respuestas Training " + payload);
        dispatch(setProyectSelectedTraining(payload))
		if (response.status === 0) {
			dispatch(addResponsesTraining(response.payload.responses));
			const headers = formatingHeaders(response.payload.responses);
			// dispatch(onSetArrayHeaders(headers));
            if (payload === "66fafd1d92bbc20883798c43") {
                dispatch(onSetArrayData(formatinDataCemex(response.payload.responses, headers)));
            }
            if (payload === "67367c71fa5b23562aee086c") {
                // FResnillo
                dispatch(onSetArrayData(formatinDataFresnilloAmacice(response.payload.responses, headers)));
            }
            //DEV | PROD
            else if (COLGATEMONTECARGA.includes(payload)) {
                // Colgate Montacarga
                dispatch(onSetArrayData(formatinDataColgateMontacarga(response.payload.responses)));
            }
            else {
                dispatch(onSetArrayData(formatinData(response.payload.responses, headers)));
            }
			return true;
		} else {
			message.error("No se consiguieron datos, recarga la pagina");
			return false;
		}
	};
};

// Update DB
export const updateApiDBwhenIsConected = () => {
	return async (dispatch, getState) => {
		const state = getState();
		const { payload } = await getAllResponsesByProjectIdLocal(1);
		if (state.vrtSlice.responses.length === payload.responses.length) {
			return;
		}
		// console.log("*/******");
		console.log(payload.responses);
		updateApiWhitLocalResponses(payload.responses);
	};
};

//

const formatinDataColgateMontacarga = (responses) => {
    const data = [];
    responses.forEach((response, i) => {
        const res = {};
        // el documento real (subido por CSV o sincronizado por Unity) solo trae "matricula"
        // plana, no un objeto student/group con nombre real -- no hay de dónde sacar un
        // nombre distinto, así que por ahora se usa la matrícula también como Nombre.
        res.Nombre = response.matricula;
        res.matricula = response.matricula;
        res._idUser = response.matricula;
        res.grupo = "";
        res.key = `${i}`;

        res.Fecha_y_hora = response.createdAt;

        const entries = Object.values(response.responses || {});
        const totalTimeSeconds = entries.reduce((total, entry) => {
            if (entry.lessonId) return total + (entry.timeSeconds || 0);
            const sectionsTime = (entry.sections || []).reduce((sum, section) => sum + (section.sectionTimeSeconds || 0), 0);
            return total + sectionsTime;
        }, 0);
        res.tiempo_total = Math.round(totalTimeSeconds / 60) + " min";

        res.cursosRealizados = entries.filter((entry) => entry.lessonId).length;
        res.evaluacionesRealizadas = entries.filter((entry) => entry.evaluationId).length;

        // se guarda toda la data cruda de las evaluaciones (secciones, pasos, categorías) para el perfil de usuario
        res.evaluaciones = response.responses;

        // por el momento se deja en 0, aún no se define el cálculo definitivo
        res.Porcentaje_total = "0%";
        res.puntaje = "0";

        data.push(JSON.parse(JSON.stringify(res)));
    });
    return data;
};

const formatinData = (responses, headersFormated) => {
	const data = [];
	responses.forEach((response, i) => {
		const res = {};
		res.Nombre = response.nameUser;
		// res.tiempo_total = response
        let fechaGMT = new Date(response.createdAt);
        // Convertir de GMT a GMT-6 (restar 6 horas)
        fechaGMT.setHours(fechaGMT.getHours());
        res.Fecha_y_hora = fechaGMT;
        res.matricula = response.matricula;
        res._idUser = response.student ? response.student._id : null
        const questions = response.responses;
        res.key = `${i}`;
        let correctAnswers = 0;
        let incorrectAnswers = 0;
        let answersSumatoria = 0;

        res.tiempo_total = Math.round(parseInt(response.durationInSeconds) / 60) + " min";

        headersFormated.forEach((header) => {
            if (header.isQuestion) {
                res[`${header.key}`] = questions[header.title] ? questions[header.title].answer : "*";
                // si las respuestas son numeros hace la sumatoria
                if (questions[header.title] && questions[header.title].answer && !isNaN(questions[header.title].answer)) {
                    answersSumatoria += parseInt(questions[header.title].answer);
                }
                //
                if (questions[header.title] && questions[header.title].answer === questions[header.title].correctAnswer) {
                    correctAnswers++;
                } else {
                    if (questions[header.title]) {
                        incorrectAnswers++;
                    }
                }
            }
        });

        // si la sumatoria es mayor a 0 (significa que las respuestas son numericas) y las despliega en la tabla
        if (answersSumatoria > 1) {
            res.sumatoria = answersSumatoria;
        }

        const percentage = Math.round((correctAnswers / (correctAnswers + incorrectAnswers)) * 100);
        res.Porcentaje_total = `${percentage}%`;
        // average += percentage;
        data.push(JSON.parse(JSON.stringify(res)));
    });
    // para la crad de % completado pro persona
    // dispatch(setAverageResponses(average / responses.length));
    return data;
};


const formatinDataCemex = (responses, headersFormated) => {
    console.log("formating CEMEX data----")
    const data = [];
    responses.forEach((response, i) => {
        const res = {};
        res.Nombre = response.nameUser;
        // res.tiempo_total = response
        let fechaGMT = new Date(response.createdAt);

        // Convertir de GMT a GMT-6 (restar 6 horas)
        fechaGMT.setHours(fechaGMT.getHours());

        // const dateStyled = new Date(fechaGMT);
        res.Fecha_y_hora = fechaGMT;
        res.matricula = response.matricula;
        const questions = response.responses;
        res.key = `${i}`;
        let correctAnswers = 0;
        let incorrectAnswers = 0;
        let answersSumatoria = 0;

        res.tiempo_total = Math.round(parseInt(response.durationInSeconds) / 60) + " min";

        headersFormated.forEach((header) => {
            if (header.isQuestion) {
                res[`${header.key}`] = questions[header.title] ? questions[header.title].answer : "*";
                // si las respuestas son numeros hace la sumatoria
                if (questions[header.title] && questions[header.title].answer && !isNaN(questions[header.title].answer)) {
                    answersSumatoria += parseInt(questions[header.title].answer);
                }
                //
                if (questions[header.title] && questions[header.title].answer === questions[header.title].correctAnswer) {
                    correctAnswers++;
                } else {
                    if (questions[header.title]) {
                        incorrectAnswers++;
                    }
                }
            }
        });

        // si la sumatoria es mayor a 0 (significa que las respuestas son numericas) y las despliega en la tabla
        if (answersSumatoria > 1) {
            res.sumatoria = answersSumatoria;
        }
        const percentage = Math.round((correctAnswers / (correctAnswers + incorrectAnswers)) * 100);

        res.Porcentaje_total = `${headersFormated.filter(header => header.isQuestion).length * 100 / 15}%`;
        res.puntaje = `${percentage}/100`;
        // average += percentage;
        data.push(JSON.parse(JSON.stringify(res)));
    });
    // para la crad de % completado pro persona
    // dispatch(setAverageResponses(average / responses.length));
    return data;
};

const formatinDataFresnilloAmacice = (responses, headersFormated) => {
    console.log(responses)
    const data = [];
    responses.forEach((response, i) => {
        const res = {};
        res.Nombre = response.nameUser;
        // res.tiempo_total = response
        let fechaGMT = new Date(response.createdAt);
        // Convertir de GMT a GMT-6 (restar 6 horas)
        fechaGMT.setHours(fechaGMT.getHours());
        res.Fecha_y_hora = fechaGMT;
        res.profesor = response.profesor;
        res.matricula = response.matricula;
        const questions = response.responses;
        res.key = `${i}`;
        let correctAnswers = 0;
        let incorrectAnswers = 0;
        let answersSumatoria = 0;

        res.tiempo_total = Math.round(parseInt(response.durationInSeconds) / 60) + " min";
        headersFormated.forEach((header) => {
            if (header.isQuestion) {
                res[`${header.key}`] = questions[header.title] ? questions[header.title].answer : "*";
                // si las respuestas son numeros hace la sumatoria
                if (questions[header.title] && questions[header.title].answer && !isNaN(questions[header.title].answer)) {
                    answersSumatoria += parseInt(questions[header.title].answer);
                }
                //
                if (questions[header.title] && questions[header.title].answer === questions[header.title].correctAnswer) {
                    correctAnswers++;
                } else {
                    if (questions[header.title]) {
                        incorrectAnswers++;
                    }
                }
            }
        });

        // si la sumatoria es mayor a 0 (significa que las respuestas son numericas) y las despliega en la tabla
        if (answersSumatoria > 1) {
            res.sumatoria = answersSumatoria;
            res.puntaje = answersSumatoria
        }
        const percentage = Math.round((correctAnswers / (correctAnswers + incorrectAnswers)) * 100);
        res.Porcentaje_total = `${percentage}%`;
        // average += percentage;
        data.push(JSON.parse(JSON.stringify(res)));
    });
    // para la crad de % completado pro persona
    // dispatch(setAverageResponses(average / responses.length));
    return data;
};
